import { render } from "./workshopTopicSelection.vue?vue&type=template&id=515849d4"
import script from "./workshopTopicSelection.vue?vue&type=script&lang=js"
export * from "./workshopTopicSelection.vue?vue&type=script&lang=js"

import "./workshopTopicSelection.vue?vue&type=style&index=0&id=515849d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__